define('flipDate/flipDate',['exports', 'pageMeta/pageMeta', 'pad/pad'], function( exports, pageMeta, pad ) {
	"use strict";

	var flipDate;
	var ONE_DAY = 1000*60*60*24;

	var calculated = false;

	// You should never have to call this. It's only exposed for testing.
	// Local Time means "the time in the time zone you want the flip date chosen from"
	// Overview of the process:
	// Get the current server time.
	// Adjust the date object so that what it says when you ask for UTC is the current hour, local time.
	// Get the hours and minutes and compare them to the flip hours and minutes
	// If it's less, subtract a day.
	exports.recalculate = function( timeString, flipTime, timeZoneOffsetStr ) {

		timeString = timeString || pageMeta.serverTime;
		flipTime = flipTime || pageMeta.flipTime || '11:00';
		timeZoneOffsetStr = timeZoneOffsetStr || pageMeta.flipTimeZoneOffset || '-0400';

		var serverTime = new Date(timeString);

		if (isNaN(serverTime)) {
			serverTime = new Date();
		}


		// Flip Time should be in the timezone of the current day.
		flipTime = flipTime.replace(':', '');
		var flipHour = +flipTime.slice(0, -2);
		var flipMinutes = +flipTime.slice(-2);

		if (isNaN(flipHour)) {
			flipHour = 11;
		}
		if (isNaN(flipMinutes)) {
			flipMinutes = 0;
		}

		// How many minutes from midnight the flip time is, in the flip time zone.
		var flipMinutesSinceMidnight = (flipHour * 60) + flipMinutes;

		
		timeZoneOffsetStr = timeZoneOffsetStr.replace(':', '');
		var timeZoneHour = +(timeZoneOffsetStr.slice(0,-2)) || 0;
		var timeZoneMinutes = +(timeZoneOffsetStr.slice(-2)) || 0;
		
		if (isNaN(timeZoneHour)) {
			timeZoneHour = -4;
		}
		if (isNaN(timeZoneMinutes)) {
			timeZoneMinutes = 0;
		}

		// create a date that will say in GMT what the flip time zone says in local time.
		var timeZoneAdjustment = ((timeZoneHour * 60) + timeZoneMinutes) * 60 * 1000;
		var adjustedDate = new Date( serverTime.getTime() + timeZoneAdjustment );
		
		var currentHour = adjustedDate.getUTCHours();
		var currentMinutes = adjustedDate.getUTCMinutes();

		var currentMinutesSinceMidnight = (currentHour * 60) + currentMinutes;

		if (currentMinutesSinceMidnight < flipMinutesSinceMidnight) {
			flipDate = new Date( adjustedDate.getTime() - ONE_DAY );
		} else {
			flipDate = adjustedDate;
		}

		calculated = true;
	};
	
	exports.getOffset = function( offset ) {
		if (!calculated) {
			exports.recalculate();
		}
		var day;
		if( offset !== 0 ) {
			day = new Date( flipDate.getTime() + (offset*ONE_DAY) );
		} else {
			day = flipDate;			
		}

		return day.getUTCFullYear()+'/'+pad(day.getUTCMonth()+1)+'/'+pad(day.getUTCDate());
	};

	exports.today     = function() { return exports.getOffset( 0); };
	exports.tomorrow  = function() { return exports.getOffset(+1); };
	exports.yesterday = function() { return exports.getOffset(-1); };


});
